import React from "react";
import { AbsoluteFill, interpolate, useCurrentFrame } from "remotion";
import { useEnvelope, ThumbIcon, ShareIcon, BellIcon, PlayIcon, CursorIcon, bellRing, YT_RED, BTN_SHADOW, TEXT_SHADOW } from "./CTAKit";

// CTA #4 — combined strip: LIKE · SHARE · SUBSCRIBE in one bottom bar.
// Each action button shows a visible "click" (cursor taps in, button presses, ripple).
const Chip: React.FC<{ icon: React.ReactNode; label: string; bg: string; delay: number; click?: boolean }> = ({ icon, label, bg, delay, click }) => {
  const frame = useCurrentFrame();
  const pop = interpolate(frame, [delay, delay + 8], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  const clickF = delay + 12;
  const press = click ? interpolate(frame, [clickF, clickF + 2, clickF + 6], [1, 0.88, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" }) : 1;
  const rip = interpolate(frame, [clickF, clickF + 14], [0.2, 1.9], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  const ripO = click ? interpolate(frame, [clickF, clickF + 14], [0.5, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp" }) : 0;
  const curO = click ? interpolate(frame, [clickF - 4, clickF - 1, clickF + 10, clickF + 16], [0, 1, 1, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp" }) : 0;
  const curDip = interpolate(frame, [clickF - 1, clickF + 2, clickF + 5], [-4, 2, -4], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  return (
    <div style={{ position: "relative", opacity: pop, transform: `translateY(${(1 - pop) * 14}px) scale(${press})` }}>
      <div style={{ display: "flex", alignItems: "center", gap: 9, background: bg, padding: "11px 20px", borderRadius: 999, boxShadow: BTN_SHADOW, color: "#fff", fontFamily: "Inter, Arial, sans-serif", fontWeight: 900, fontSize: 21, letterSpacing: 1 }}>
        {icon}
        {label}
      </div>
      {/* click ripple */}
      <div style={{ position: "absolute", left: "50%", top: "50%", width: 80, height: 44, borderRadius: 999, border: "3px solid #fff", opacity: ripO, transform: `translate(-50%,-50%) scale(${rip})`, pointerEvents: "none" }} />
      {/* cursor tapping the button */}
      <div style={{ position: "absolute", left: "62%", top: "58%", opacity: curO, transform: `translateY(${curDip}px)`, pointerEvents: "none", filter: "drop-shadow(0 2px 3px rgba(0,0,0,0.5))" }}>
        <CursorIcon size={28} />
      </div>
    </div>
  );
};

export const CTACombinedBar: React.FC<{ bottom?: number }> = ({ bottom = 70 }) => {
  const { o, y, fps } = useEnvelope();
  const frame = useCurrentFrame();
  return (
    <AbsoluteFill style={{ justifyContent: "flex-end", alignItems: "center", paddingBottom: bottom }}>
      <div style={{ opacity: o, transform: `translateY(${y}px)`, display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
        <div style={{ color: "#fff", fontFamily: "Inter, Arial, sans-serif", fontWeight: 800, fontSize: 18, letterSpacing: 3, textShadow: TEXT_SHADOW }}>
          IF YOU LEARNED SOMETHING NEW
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <Chip icon={<ThumbIcon size={22} />} label="LIKE" bg="#2563eb" delay={Math.round(fps * 0.2)} click />
          <Chip icon={<ShareIcon size={22} />} label="SHARE" bg="#16a34a" delay={Math.round(fps * 0.4)} click />
          <Chip icon={<PlayIcon size={20} />} label="SUBSCRIBE" bg={YT_RED} delay={Math.round(fps * 0.6)} click />
          <div style={{ marginLeft: 2 }}>
            <Chip icon={<BellIcon size={22} ring={bellRing(frame, fps, 0.9)} />} label="" bg="rgba(20,20,24,0.92)" delay={Math.round(fps * 0.8)} />
          </div>
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
